import React from 'react';
import { Typography } from '@mui/material';
import { colors } from '../theme/theme';

export type UserRemoveWarnings = {
  hasUpcomingBookings: boolean;
  hasActivePacks: boolean;
};

type Props = {
  name: string;
  warnings: UserRemoveWarnings;
  isStudioRole?: boolean;
};

const highlightSx = { color: colors.primary };

export const RemoveUserConfirmMessage: React.FC<Props> = ({
  name,
  warnings,
  isStudioRole = true,
}) => {
  const { hasUpcomingBookings, hasActivePacks } = warnings;

  if (!hasUpcomingBookings && !hasActivePacks) {
    return (
      <Typography variant="body2" color="text.secondary">
        {isStudioRole
          ? `Remove ${name} from your studio? They will no longer appear in your member list.`
          : `Are you sure you want to delete "${name}"? Their data stays on record, but they'll need to create their account again to use SweatSocial.`}
      </Typography>
    );
  }

  const suffix = '. Are you sure you want to remove them from your studio?';

  return (
    <Typography variant="body2" color="text.secondary" component="span">
      {name} has{' '}
      {hasUpcomingBookings && hasActivePacks ? (
        <>
          <Typography component="span" variant="body2" sx={highlightSx}>
            an upcoming booking
          </Typography>
          {' and '}
          <Typography component="span" variant="body2" sx={highlightSx}>
            an active pack
          </Typography>
        </>
      ) : hasUpcomingBookings ? (
        <Typography component="span" variant="body2" sx={highlightSx}>
          an upcoming booking
        </Typography>
      ) : (
        <Typography component="span" variant="body2" sx={highlightSx}>
          an active pack
        </Typography>
      )}
      {suffix}
    </Typography>
  );
};

export const emptyUserRemoveWarnings = (): UserRemoveWarnings => ({
  hasUpcomingBookings: false,
  hasActivePacks: false,
});
